var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHmTestShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 624.74,
    height: 435.671,
    viewBox: "0 0 624.74 435.671",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector 34",
    filter: "url(#filter0_i_0_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.954 32.1183L156.459 0.12096C145.855 -0.944325 135.819 5.11028 131.817 14.9871L1.76636 335.916C-3.56998 349.084 3.63912 363.98 17.2774 367.966L245.663 434.707C248.95 435.668 252.405 435.914 255.795 435.429L585.086 388.313C594.6 386.952 602.384 380.046 604.87 370.762L623.923 299.6C625.508 293.682 624.769 287.381 621.858 281.99L493.673 44.5951C489.889 37.5883 482.877 32.9143 474.954 32.1183Z",
    fill: "#FFE743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.954 32.1183L156.459 0.12096C145.855 -0.944325 135.819 5.11028 131.817 14.9871L1.76636 335.916C-3.56998 349.084 3.63912 363.98 17.2774 367.966L245.663 434.707C248.95 435.668 252.405 435.914 255.795 435.429L585.086 388.313C594.6 386.952 602.384 380.046 604.87 370.762L623.923 299.6C625.508 293.682 624.769 287.381 621.858 281.99L493.673 44.5951C489.889 37.5883 482.877 32.9143 474.954 32.1183Z",
    fill: "url(#paint0_linear_0_306)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_0_306",
    x: 0,
    y: 0,
    width: 624.74,
    height: 435.671,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_306"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_306",
    x1: 309.093,
    y1: -1.6763,
    x2: 309.093,
    y2: 436.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44279,
    stopColor: "#101010",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986949,
    stopColor: "#17171B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmTestShape);
export default __webpack_public_path__ + "static/media/hmTestShape.03c06b74ed1293288dc7b35bb7ec33ec.svg";
export { ForwardRef as ReactComponent };